import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from 'styled-components';
import { get } from '../../../styles/constant';
const DefaultFooter = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
const Wrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  padding: ", " ", " ", ";\n  border-top: 1px solid ", ";\n"])), get('space.15'), get('space.10'), get('space.10'), get('colors.functional.grey.400'));
const Components = {
  DefaultFooter,
  Wrapper
};
export { Components };